import { xhr } from '@/api/config/Repository'
import CreateVMISLPRepository from '../CreateVMISLPRepository'
import CreateVMISLPRequestDTO from '../dto/CreateVMISLPRequestDTO'
export default class CreateVMISLPRepositoryImpl implements CreateVMISLPRepository {
  async createVMISLPData (request: CreateVMISLPRequestDTO): Promise<any> {
    const endpoint = 'slp/createVMISLP'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<any, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: CreateVMISLPRepositoryImpl.ts:12 ~ createVMISLPData ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }

  async createStandardSLPData (request: any): Promise<any> {
    const endpoint = 'slp/createStandardSLP'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.post<any, any>(endpoint, request, { headers })
    console.log('LOG~ ~ file: CreateVMISLPRepositoryImpl.ts:26 ~ createStandardSLP ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }

  async createNationalSLPData (request: any): Promise<any> {
    const endpoint = 'slp/createNationalSLP'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.post<any, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getFileIdData (request: any): Promise<any> {
    const endpoint = 'order/fileDropdown'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.post<any, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getStandardOrderDetailsData (request: any): Promise<any> {
    const endpoint = 'order/fetchOrderDetail'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.post<any, any>(endpoint, request, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }
}
